const filters = {

    'filters.waiting.sync': 'Waiting for sync',
    'filters.adjusted.synced': 'Adjusted and synced',

    'filters.adjusted.show': 'Show in webshop is adjusted',
    'filters.adjusted.name': 'Name is adjusted',
    'filters.adjusted.price': 'Price is adjusted',
    'filters.adjusted.unique_code': 'Product number is adjusted',
    'filters.adjusted.category': 'Category is adjusted',
    'filters.adjusted.additional_categories': 'Additional categories are set',
    'filters.adjusted.seo': 'SEO is adjusted',

    'filters.remove': 'Remove filter options',

    'filters.product.types.critical': 'Critical',
    'filters.product.types.info': 'Info',

    'filters.product.jobs.collect': 'Collect',
    'filters.product.jobs.connect': 'Connect',
    'filters.product.jobs.sync': 'Sync',

};

export default filters;
